export const PLUSFIVE = 'PLUSFIVE';
export const PLUSFOUR = 'PLUSFOUR';
export const PLUSTHREE = 'PLUSTHREE';
export const PLUSTWO = 'PLUSTWO';
export const PLUSONE = 'PLUSONE';
export const RESET_SCORE = 'RESET_SCORE';